/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Button, Form, message, Spin, Col, Select, Row, Checkbox } from "antd";
import moment from "moment";
import RateCharges from "./RateCharges";
import API from "../../../api";
import urls from "../../../api/urls";
import AccountRateCard from "./AccountRateCard";

import RateComission from "./RateComission";
import QuotationForm from "./QuotationForm";
const { CREATE_RATE_CARD } = urls;
import { customerOnboardingAPI } from "../../../api/LeadApi";
import { masterRateCardAPI } from "../../../api/RateCardApi";
import RateCardMatrix from "../../../views/DynamicRateCard/DynamicRateCardMatrix";
import validateRateCard from "../../../views/DynamicRateCard/rateUtil";
const AccountQuotation = ({
  getData,
  handleStepsChange = () => {},
  goBackStep,
  accountData,
  loader,
  defaultRateCharge,
  stateCode,
  calculationBasisList,
  userType,
  defaultRateList,
  rateCardType,
  tabChange,
  disableEdit = false,
}) => {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [clickedButton, setClickedButton] = useState(null);
  const [rateMatrixAccount, setRateMatrixAccount] = useState({});
  const [rateChargesData, setRateChargesData] = useState([]);
  const [currentQuotation, setCurrentQuotation] = useState(null);

  const [quotationRateCharges, setquotationRateCharge] = useState([]);
  const [quotationRateMatrixAccount, setQuotationRateMatrixAccount] = useState(
    {}
  );
  const [rateCardError, setRateCardError] = useState([]);
  const [rateCardTypes, setRateCardTypes] = useState({});
  const [rateChargeErr, setRateChargeErr] = useState([]);
  const [templateDetails, setTemplateDetails] = useState(null);
  const [quotationStatus, setQuotationStatus] = useState(null);
  //const [commissionRate, setComissionRate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addRateMatrix, setAddRateMatrix] = useState(true);
  const [defaultZones, setDefaultZones] = useState([]);

  const dateFormat = "DD-MM-YYYY";

  const rateType = rateCardType;

  //   useEffect(() => {
  //     if (getData?.cpLeadQuotation) {
  //       getQuotationDetail(getData?.cpLeadQuotation);
  //     }
  //   }, [getData?.cpLeadQuotation]);

  useEffect(() => {
    if (Object.keys(accountData).length > 0) {
      getQuotationDetail();
    }
  }, [accountData]);

  // useEffect(() => {
  //   if (templateDetails?.charges) {
  //     setquotationRateCharge(templateDetails?.charges);
  //   }

  //   if (templateDetails?.rates?.[0]?.rate) {
  //     setQuotationRateMatrixAccount(templateDetails?.rates?.[0]?.rate);
  //   }
  // }, [templateDetails]);

  // useEffect(() => {
  //   if (
  //     templateDetails?.rates?.[0]?.rate &&
  //     Object.keys(templateDetails?.rates?.[0]?.rate).length > 0
  //   ) {
  //     setAddRateMatrix(true);
  //   } else {
  //     setAddRateMatrix(false);
  //   }
  // }, [templateDetails]);

  useEffect(() => {
    setLoading(loader);
  }, [loader]);

  const getQuotationDetail = async () => {
    const data = accountData;

    form.setFieldsValue({
      fromDate: moment(data?.fromDate, dateFormat),
      toDate: moment(data?.toDate, dateFormat),
      billingCycle: data?.billingCycle,
      type: data?.type,
      commitedBusiness: data?.commitedBusiness,
      invoiceType: data?.invoiceType,
    });
    setquotationRateCharge(data?.charges);
    setQuotationStatus(data?.approvalStatus);
    form1.setFieldsValue({
      commission: data?.commission,
      // slab: data?.commission?.[0]?.slab,
      // rateType: data?.commission?.[0]?.rateType,
    });
    // if (
    //   data?.rates?.[0]?.rate &&
    //   Object.keys(data?.rates?.[0]?.rate).length > 0
    // ) {
    //   setAddRateMatrix(true);
    // } else {
    //   setAddRateMatrix(false);
    // }
    data?.rates?.forEach((item) => {
      switch (item?.type) {
        case rateType:
          setQuotationRateMatrixAccount(item?.rate);
          //setRateMatrixAccount(item?.rate);
          break;

        default:
          break;
      }
    });
  };

  const setRateCharge = (data) => {
    setRateChargesData(data);
  };

  const saveRateCard = async (val) => {
    //const vals = await form1.validateFields();

    // console.log(vals);
    let user =
      {
        CLIENT: "clientLeadId",
        COMPANY: "customerIdCompany",
      }[userType] || "customerId";

    try {
      const vals = await form1.validateFields();
      let comission = form1.getFieldsValue();
      const result = validateCharges(rateChargesData);
      if (result.length > 0) {
        message.error(result);
        window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
        return;
      }
      if (addRateMatrix) {
        const rateCardError = validateRateCard(
          rateMatrixAccount,
          rateCardTypes
        );
        setRateCardError(rateCardError);
        if (rateCardError.length > 0) {
          message.error("Please fill the zero value in the matrix");
          return;
        }
      }

      let travelMode = rateCardTypes?.travelMode?.[0];
      let docType = rateCardTypes?.docType?.[0];
      let shippingType = rateCardTypes?.shippingType?.[0];
      const allZones =
        rateMatrixAccount?.[docType]?.[travelMode]?.[shippingType]?.[0];
      const customZones = Object.keys(allZones || {}).filter(
        (key) => !defaultZones.includes(key)
      );
      let payloadRates = [];
      if (addRateMatrix) {
        payloadRates = [
          {
            rate: rateMatrixAccount || {},
            type: rateType,
          },
        ];
      }
      const checkBtn = clickedButton === "saveAndContinueButton";
      const payload = {
        ...val,
        type: rateType,
        stateCode,
        commitedBusiness: parseInt(val?.commitedBusiness),
        userId: localStorage.getItem(user),
        toDate: val?.toDate ? moment(val.toDate).format(dateFormat) : null,
        fromDate: val?.fromDate
          ? moment(val.fromDate).format(dateFormat)
          : null,
        commission: comission?.commission,
        rates: payloadRates,
        charges: rateChargesData?.map((item) => ({
          chargesHead: item?.head,
          rateType: item?.chargeType,
          pricingType: item?.pricingType,
          appliesOn: item?.appliesOn,
          calculationBasis: item?.calculationBasis,
          rate:
            item?.pricingType === "SLAB" || item?.chargeType === "PERCENTAGE"
              ? null
              : parseFloat(item?.rate),
          slabId: item?.pricingType === "FIXED" ? null : item?.slabId,
          percentage:
            item?.pricingType === "SLAB" || item?.chargeType === "VALUE"
              ? null
              : parseFloat(item?.percentage),
        })),
      };

      setLoading(true);
      let quoteName = accountData.name || currentQuotation;
      let res;
      res =
        (getData?.quotations?.some((e) => e.rateCardType === rateType) &&
          quotationStatus?.toUpperCase() === "PENDING") ||
        currentQuotation
          ? await API.Api(`${CREATE_RATE_CARD}/${quoteName}`).patch(payload)
          : await API.Api(CREATE_RATE_CARD).post(payload);
      if (res?.status) {
        setCurrentQuotation(res?.response?.data?.name);
        setLoading(false);
        const id = localStorage.getItem(user);
        let response1 = await customerOnboardingAPI.patchLead(id, {
          quotations: [
            {
              rateCardType: rateType,
              rateCardName: res?.response?.data?.name,
            },
          ],
        });
        if (response1?.status) {
          message.success("Quotation added successfully.");
          if (checkBtn && rateType === "CASH") {
            //handleStepsChange(1);
            window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
            tabChange();
          } else if (checkBtn && rateType === "ACCOUNT") {
            handleStepsChange(1);
          }
        } else {
          message.error(response1?.response?.data?.message);
        }
      } else {
        setLoading(false);
        let msg = "";

        if (res?.response?.data?.errors?.length > 0) {
          res?.response?.data?.errors?.map((e) => {
            msg += e;
          });
        } else {
          msg += res?.response?.data?.message;
        }
        message.error(msg || "Internal server error.");
      }
    } catch (errorInfo) {
      //console.log(errorInfo);
      window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
    }
  };

  const validateCharges = (charges) => {
    const errors = [];

    charges.forEach((charge) => {
      const {
        chargeType,
        appliesOn,
        pricingType,
        activeType,
        rate,
        percentage,
        slabId,
      } = charge;

      if (!chargeType || !appliesOn || !pricingType) {
        //errors.push(`Missing required fields in head: ${charge.head}`);
        errors.push(charge.head);
      }

      if (activeType === "rate" && !rate) {
        errors.push(charge.head);
        // errors.push(
        //   `Rate is missing for activeType "rate" in head: ${charge.head}`
        // );
      } else if (activeType === "percentage" && !percentage) {
        errors.push(charge.head);
        // errors.push(
        //   `Percentage is missing for activeType "percentage" in head: ${charge.head}`
        // );
      } else if (activeType === "slabId" && !slabId) {
        errors.push(charge.head);
        // errors.push(
        //   `Slab ID is missing for activeType "slabId" in head: ${charge.head}`
        // );
      }
    });
    setRateChargeErr(errors);
    if (errors.length > 0) {
      return `Please fill values of ${errors}`;
    }

    return errors;
  };

  const changeData = (data) => {
    setTemplateDetails(data);
  };

  return (
    <Spin spinning={loading}>
      <Form
        className="global-form"
        layout="vertical"
        form={form}
        scrollToFirstError={{
          behavior: "smooth",
          block: "center",
          inline: "center",
        }}
        onFinish={saveRateCard}
        initialValues={{
          fromDate: moment(new Date(), dateFormat),
        }}
      >
        <Row className="global-form-row p-1" gutter={20}>
          <QuotationForm
            disable={
              accountData?.approvalStatus?.toLowerCase() === "approved" ||
              disableEdit
            }
            getTemplateDetails={(data) => changeData(data)}
            showInvoiceType={false}
          />
          {/* <Col className="form-inputs" span={4}>
            <Form.Item name="ratecardtemplate" label="Select Rate Template">
              <Select
                placeholder="Select Rate Template"
                options={defaultRateList}
                onChange={(val) => setAllRateDetails(val)}
                disabled={
                  accountData?.approvalStatus?.toLowerCase() === "approved"
                }
              />
            </Form.Item>
          </Col> */}
        </Row>
        {userType !== "CLIENT" && (
          <div>
            <RateComission
              //commissionRate={(data) => setComissionRate(data)}
              formName={form1}
              defaultRateCharge={defaultRateCharge}
              disable={
                accountData?.approvalStatus?.toLowerCase() === "approved" ||
                disableEdit
              }
            />
          </div>
        )}
        <div>
          <RateCharges
            rateCharge={setRateCharge}
            quotationRateCharge={
              templateDetails?.charges || quotationRateCharges
            }
            templateCharges={templateDetails?.charges}
            stateCode={stateCode}
            errors={rateChargeErr}
            setError={() => setRateChargeErr([])}
            defaultRateCharge={defaultRateCharge}
            calculationBasisList={calculationBasisList}
            disable={
              accountData?.approvalStatus?.toLowerCase() === "approved" ||
              disableEdit
            }
            editHighValue={getData?.status?.toUpperCase() === "APPROVED"}
            oldRateCharge={JSON.stringify(quotationRateCharges)}
          />
        </div>

        {/* <AccountRateCard
          setRateMatrix={setRateMatricAccount}
          quotationRateMatrixs={quotationRateMatrixAccount}
          templateType={
            accountData?.approvalStatus?.toLowerCase() === "approved"
              ? "view"
              : "create"
          }
        /> */}
        {/* <div className="d-flex ml-2 mt-2">
          <Checkbox
            onChange={(e) => setAddRateMatrix(e.target.checked)}
            className="custom-checkbox-add-rate-matrix"
            checked={addRateMatrix}
            disabled={accountData?.approvalStatus?.toLowerCase() === "approved"}
          >
            <span className="f-18 fw-500">Add RateMatrix</span>
          </Checkbox>
        </div>
        {addRateMatrix && ( */}
        <RateCardMatrix
          getData={
            templateDetails?.rates?.[0]?.rate || quotationRateMatrixAccount
          }
          setMatrixData={(data) => {
            setRateMatrixAccount(data);
          }}
          actionEdit={disableEdit ? false : true}
          notCloneZone={true}
          setRateCardOptionTypes={(data) => setRateCardTypes(data)}
          rateCardError={rateCardError}
          getAllDefaultZones={(data) => setDefaultZones(data)}
          disableNewWeightSlabs={true}
          editHighValue={getData?.status?.toUpperCase() === "APPROVED"}
        />

        {/* <div className="flex-end m-1">
          <Button className="cancel-btn ml-1 w-15" onClick={goBackStep}>
            BACK
          </Button>
          {userType === "CP" && (
            <Button
              className="cancel-btn ml-1"
              id="saveNContinue"
              onClick={() => {
                window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
                handleStepsChange();
              }}
            >
              SKIP & CONTINUE
            </Button>
          )}
          <Button className="cancel-btn ml-1  w-15" htmlType="submit">
            SAVE
          </Button>
          <Button
            htmlType="submit"
            className="save-btn  ml-1"
            id="saveNContinue"
            onClick={() => setClickedButton("saveAndContinueButton")}
          >
            SAVE & CONTINUE
          </Button>
        </div> */}
        <div className="flex-end m-1">
          <Button className="cancel-btn ml-1 w-15" onClick={goBackStep}>
            BACK
          </Button>
          {accountData?.approvalStatus?.toLowerCase() !== "approved" ? (
            <>
              {(userType === "CP" || userType === "COMPANY") && (
                <Button
                  className="cancel-btn ml-1"
                  id="saveNContinue"
                  onClick={() => {
                    window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
                    handleStepsChange();
                  }}
                >
                  SKIP & CONTINUE
                </Button>
              )}
              <Button className="cancel-btn ml-1 w-15" htmlType="submit">
                SAVE
              </Button>
              <Button
                htmlType="submit"
                className="save-btn ml-1"
                id="saveNContinue"
                onClick={() => setClickedButton("saveAndContinueButton")}
              >
                SAVE & CONTINUE
              </Button>
            </>
          ) : (
            <Button
              onClick={() => {
                handleStepsChange();
              }}
              className="save-btn  ml-1"
            >
              NEXT
            </Button>
          )}
        </div>
      </Form>
    </Spin>
  );
};
export default AccountQuotation;
